import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HowToPlayModal from './HowToPlayModal';

interface HowToPlayButtonProps {
  className?: string;
}

const HowToPlayButton: React.FC<HowToPlayButtonProps> = ({ className = '' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div 
      onClick={() => setIsModalOpen(true)}
      className={`flex items-center gap-2 text-gray-800 text-lg font-medium cursor-pointer hover:text-gray-900 hover:-translate-y-0.5 transition-all duration-300 drop-shadow-sm ${className}`}
    >
      <span className="w-8 h-8 bg-gray-800/10 border-2 border-gray-800/30 rounded-full flex items-center justify-center font-bold text-gray-800">
        ?
      </span>
      <span>{t('howToPlay.button')}</span>
      <HowToPlayModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default HowToPlayButton;